export default "/images/81cc49fc71d5050c5a611b9d62984f15.png";